import { updateConnectedRequests } from '../../../api'
import { EMPTY_OBJECT } from '../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { SIZE } from '../../../constants/size'
import { useMassActions, useNotification, useTimeZone } from '../../../hooks'
import { FormModal } from '../../Form'

import {
  CONNECTED_REQUESTS_MASS_EDIT_MODAL_FORM_QA_NAME,
  CONNECTED_REQUESTS_MASS_EDIT_MODAL_QA_NAME,
} from './ConnectedRequestsMassEditModal.constants'
import {
  getConnectedRequestsMassEditNotificationTitle,
  getPreparedInitialValues,
  getSubmitPayload,
  getValidationSchema,
} from './ConnectedRequestsMassEditModal.utils'
import { ConnectedRequestsMassEditModalActions } from './ConnectedRequestsMassEditModalActions'
import { ConnectedRequestsMassEditModalFields } from './FormFields'

import * as styles from './ConnectedRequestsMassEditModal.module.css'

function ConnectedRequestsMassEditModal({
  initialValues,
  requestId,
  onClose,
  onOpenConnectedRequestsPreview,
  onSuccess,
}) {
  const timezone = useTimeZone()

  const { handleAddErrorNotification } = useNotification()
  const {
    getAsyncTaskId,
    handleAddAsyncMassActionNotification,
    handleAddFinishMassActionNotification,
  } = useMassActions({
    getNotificationTitle: getConnectedRequestsMassEditNotificationTitle,
    onSuccessHandler: onSuccess,
  })

  const preparedInitialValues = getPreparedInitialValues(initialValues)

  const validationSchema = getValidationSchema({ timezone })

  function handleSubmit({ values }) {
    return updateConnectedRequests({
      data: getSubmitPayload({ timezone, values }),
      id: requestId,
    })
      .then(({ data }) => {
        const asyncTask = getAsyncTaskId(data)

        if (asyncTask) {
          handleAddAsyncMassActionNotification({
            task: asyncTask,
          })
          onClose?.()

          return
        }

        handleAddFinishMassActionNotification(data, EMPTY_OBJECT)
        onSuccess?.()
        onClose?.()
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  return (
    <FormModal
      Fields={ConnectedRequestsMassEditModalFields}
      containerProps={{
        boxSize: SIZE.X_LARGE,
        qaName: CONNECTED_REQUESTS_MASS_EDIT_MODAL_QA_NAME,
      }}
      formBodyProps={{
        ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
        Actions: ConnectedRequestsMassEditModalActions,
        contentClassName: styles.content,
        contentProps: {
          contentWrapperClassName: styles.contentWrapper,
          size: SIZE.LARGE,
        },
        submitQaName: QA_NAME_SAVE_BTN,
      }}
      formFieldsProps={{
        requestId,
        onOpenConnectedRequestsPreview,
      }}
      formProps={{
        qaName: CONNECTED_REQUESTS_MASS_EDIT_MODAL_FORM_QA_NAME,
      }}
      formTitle='Modal.ConnectedRequestsMassEditModalTitleKey'
      initialValues={preparedInitialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ConnectedRequestsMassEditModal
